<template> 
<div class="w100">
    <span class="wallet-title" :class="{'active-wallet': opened}" 
    @click="open">
        <p>{{ groupedByClientName ? wallet[0].ClientName : wallet[0].Description }}</p>
        <div class="wallet-arrow-wrap">
            <p><span>{{ sumBalance }}</span>
            </p>
            <md-icon class="arrow-down-icon-aml  md-icon-size-065x">
                <svg height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z" /></svg>
            </md-icon>
        </div>
    </span>
    <div class="w100" v-show="opened">
        <div v-for="innerWallet in innerGroup" class="w100 wallet-item" :key="`accordion-${wallet.WalletId}`">
              <div v-if="!Array.isArray(innerWallet)" @click="$emit('setActiveSubwallet', innerWallet)" class="text_medium protfolio-subwallet subwallets-flex accordioned">
              <span class="wallet-field">{{ groupedByClientName ? innerWallet.ClientName : innerWallet.Description }}</span>
              <span class="wallet-field">{{ groupedByClientName ? innerWallet.Description : innerWallet.ClientName }}</span>
              <div class="wallet-field">
                  <span class="subwallet-balance">{{ innerWallet.Balance }}</span>
                  <span>{{ innerWallet.Asset }}</span>
              </div>
              </div>
              <InnerAccordion v-else :innerWallet="innerWallet" :groupByinnerDescription="groupByinnerDescription"
              :groupByinnerClient="groupByinnerClient" @setInnerSubwallet="setInnerSubwallet"/>
            
        </div>
    </div>
</div>
</template>
<script>
/* eslint-disable */
import { i18n } from '@js/i18n'
import InnerAccordion from './InnerAccordion.vue'
export default {
  name: "AccordionSubWallet",
  emits: ['setActiveSubwallet'],
  components: { InnerAccordion },
  props: {
    wallet: {
      type: Array,
      required: true
    },
    groupedByClientName: {
      type: Boolean,
      required: true
    },
    groupByinnerDescription: {
      type: Boolean,
      required: true
    },    
    groupByinnerClient: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      opened: false,

      i18n
    }
  },
  computed: {
    sumBalance () {
     return Object.entries(
            this.wallet.reduce((acc, { Balance, Asset }) => {
                if (!acc[Asset]) {
                acc[Asset] = 0;
                }
                acc[Asset] += +Balance;
                return acc;
            }, {})
            )
            .map(([Asset, Balance]) => `${Balance} ${Asset}`)
            .join(' ')
    },
    innerGroup () {
      return this.groupInner(this.wallet)
    }
  },
  methods: {
    setInnerSubwallet (group) {
      this.$emit('setActiveSubwallet', group)
    },
    open () {
        this.opened = !this.opened
    },
    groupInner (arr) {
      if (!this.groupByinnerDescription && !this.groupByinnerClient) {
        return this.wallet
      }
      const map = new Map()
      const result = []
      if (this.groupByinnerDescription) {
        arr.forEach(wallet => {
          const desc = wallet.Description
          if (map.has(desc)) {
            map.get(desc).push(wallet)
          } else {
            map.set(desc, [wallet])
          }
        })
      } else if (this.groupByinnerClient) {
        arr.forEach(wallet => {
          const desc = wallet.ClientName
          if (map.has(desc)) {
            map.get(desc).push(wallet)
          } else {
            map.set(desc, [wallet])
          }
        })
      }
      map.forEach(group => {
        if (group.length > 1) {
          result.push(group)
        } else {
          result.push(group[0])
        }
      })
      return result
    },
  }
}
</script>

<style scoped lang="scss">
.inner {
  border-top: 1px solid black;
  border-bottom: 1px solid black;
  .grouped-title {
    margin-top: 5px;
  }
}
.wallet-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.wallet-arrow-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
}
.active-wallet {
    padding-bottom: 20px;
    .arrow-down-icon-aml {
        transform: rotate(180deg);
    }
}
.subwallets-flex {
    width: 100%;
    display: flex;
    justify-content: space-between;
    .wallet-field {
      display: block;
      width: 33%;
      text-align: right;
      &:nth-child(2) {
        text-align: center;
      }
      &:first-child {
        text-align: left;
      }
    }
}
.w100 {
    width: 100%;
}
.accordioned {
    padding: 15px 5px;
    transition: all 0.4s ease-in-out;
    &:hover {
        background-color:rgba(0, 0, 0, 0.1);
    }
}
</style>


// WEBPACK FOOTER //
// src/vue/app/dashboard/index/AccordionSubWallet.vue